import { Alert } from '@app/components'
import { boxProperties, maxTablet } from '@app/styles'
import { AlertProps, LayoutProps, SiderProps } from '@app/types'
import { Layout as AntLayout } from 'antd'
import styled from 'styled-components'

export const StyledSider = styled((props: SiderProps) => <AntLayout.Sider {...props} />)`
  && {
    align-self: stretch;
    background: ${(props) => props.theme?.color?.SECONDARY ?? '#162231'} !important;
    overflow: hidden;
  }

  .ant-layout-sider-children {
    display: flex !important;
    flex-direction: column;
    height: 100%;
    min-height: 0;
  }

  .ant-menu.ant-menu-root {
    padding: 0 !important;
  }

  .ant-menu-item {
    margin-inline: 0 !important;
    width: 100% !important;
  }

  .ant-menu-item:first-child {
    margin-block-start: 0 !important;
    border-start-start-radius: 0 !important;
    border-start-end-radius: 0 !important;
  }

  .ant-menu-inline .ant-menu-item {
    padding-inline: 24px !important;
  }

  &.ant-layout-sider-collapsed .ant-menu-item {
    display: flex !important;
    align-items: center !important;
    justify-content: center !important;
    padding-inline: 0 !important;
    border-radius: 0 !important;
  }

  &.ant-layout-sider-collapsed .ant-menu-item .ant-menu-item-icon {
    margin-inline: 0 !important;
  }

  &.ant-layout-sider-collapsed .ant-menu-item .ant-menu-title-content {
    display: none !important;
  }

  &.ant-layout-sider-collapsed {
    min-width: 80px !important;
    max-width: 80px !important;
  }

  &:not(.ant-layout-sider-collapsed) {
    min-width: 250px !important;
    max-width: 250px !important;
  }

  @media only screen and (max-width: ${maxTablet}) {
    min-width: auto !important;
  }
`

export const StyledContent = styled((props: LayoutProps) => {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const { sidebar, header, ...otherProps } = props
  return <AntLayout.Content {...otherProps} />
})`
  ${(props) => {
    let styles = ''
    if (props.sidebar) {
      styles += `
        padding: 50px;
      `
    }
    if (props.header) {
      styles += `
        height: 100%;
        min-height: 0;
      `
    }
    return styles
  }}
  background: ${(props) => props.theme?.color?.baseBgColor ?? '#fff'};
  overflow: auto;
  padding-bottom: 100px;
  ${boxProperties};

  @media only screen and (max-width: ${maxTablet}) {
    padding: 25px;
    padding-bottom: 50px;
  }
`

export const StyledHeader = styled((props: LayoutProps) => {
  return <AntLayout.Header {...props} />
})`
  background: ${(props) => props.theme?.color?.SECONDARY ?? '#162231'};
  /* 1000 is the zIndex of the modal */

  box-shadow: 0 1px 0 0 rgb(112 112 112 / 16%) !important;
  padding: 0;
  position: sticky;
  top: 0;
  width: 100%;
  z-index: 1000;
  ${boxProperties};
`

export const StyledBanner = styled((props: AlertProps) => <Alert {...props} />)`
  flex-shrink: 0;
  padding: 10px 50px;
  border: none;
  border-radius: 0;
  && {
    .ant-alert-message {
      display: flex;
      justify-content: center;
    }
  }
`
